export enum SearchType {
  Document = 1,
  PDC = 2,
  Process = 3,
  ActivityInput = 4,
  ActivityOutput = 5,
  ExternalLink = 6,
  CabinetTypical =7,
}